// The reducer is a pure function that takes the previous state and an action,
// and returns the next state.

// For now, just remember that the reducer must be pure.
// Given the same arguments, it should calculate the next state and return it.
// No surprises. No side effects. No API calls. No mutations. Just a calculation
// { ...state, ...newState }
// https://stackoverflow.com/questions/46761718/update-nested-object-using-object-assign

const user = (
	state = {
		status: false,
	}, action ) => {
	switch ( action.type ) {
		case 'USER_STATUS_SET':
			return {
				...state,
				status: action.status,
			};

		default:
			return state;
	}
};

export default user;



// WEBPACK FOOTER //
// ./src/reducers/user.js